const variants = {
    link: {},
    container: {
        maxWidth: '1400px',
        width: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
}

export default variants
